import type React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage(): React.JSX.Element {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
      <h1 className="text-3xl font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground">That route does not exist in TekVoice.</p>
      <Button asChild>
        <Link to="/">Back to batches</Link>
      </Button>
    </div>
  );
}
